import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from "@angular/common/http";
import { environment } from "../../../environment/environment";

import { catchError, map } from "rxjs/operators";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ManualsService {
  httpOptions: any;
  constructor(private httpClient: HttpClient) {}
  getallprojectlist(clientID: any) {    
    return this.httpClient.post<any>(
      environment.url + "/customers/masters/getprojectlist",
      clientID
    );
  }
  getmanuallist(data: any) {
    return this.httpClient.post<any>(
      environment.url + "/customers/masters/getdocumentlist",
      data
    );
  }
  open_document() {
    return environment.url + "/customerSoFolder/opendocument";
  }

  //////////////
  GetCustomersProjectList(data:any): any {
    return this.httpClient.post(
      environment.url + "/common/getRecords",
      data
    );
  }

  checkFileExistence(filePath: string): Observable<boolean> {
    return this.httpClient.get(filePath, { responseType: "blob" }).pipe(
      map(() => true), // File exists if the request is successful
      catchError(() => of(false)) // File doesn't exist if there's an error
    );
  }
}
